export const fetchConditionalPropertyOptionRules = (objectTypeId, http, offset) => {
  return http.get(`conditional-properties/v2/options/${objectTypeId}/unmerged/paged`, {
    query: {
      pageSize: 100,
      offset
    }
  }).then(conditionalPropertyOptionRules => {
    const {
      results,
      hasMore,
      offset: newOffset
    } = conditionalPropertyOptionRules;
    const transformedRules = results.map(rule => {
      const {
        dependentFieldName,
        dependentOptions,
        controllingField: {
          fieldName,
          fieldValue
        },
        id
      } = rule;
      return {
        id,
        objectTypeId,
        dependentPropertyName: dependentFieldName,
        allowedPropertyOptions: dependentOptions,
        controllingPropertyValues: [{
          propertyName: fieldName,
          value: fieldValue
        }]
      };
    });

    if (hasMore) {
      return fetchConditionalPropertyOptionRules(objectTypeId, http, newOffset).then(moreRules => transformedRules.concat(moreRules));
    }

    return transformedRules;
  }).catch(err => {
    console.log(err);
    throw err;
  });
};
export const fetchPropertyDefinitions = (objectTypeId, http) => {
  return http.get(`/properties/v4/${objectTypeId}`).then(properties => {
    const returnProperties = {};

    for (const property of properties) {
      returnProperties[property.property.name] = property.property;
    }

    return returnProperties;
  });
};
export const fetchConditionalPropertyRules = (objectTypeId, http, query) => {
  // Semi-paginated unified endpoint will blend stage change and CP rules
  // All stage change rules returned at once (in unpaginated fashion)
  // If offset provided, then only fetch CP rules (which are paginated)
  // see https://git.hubteam.com/HubSpot/CRM-Issues/issues/12045#issuecomment-4108084
  return http.get(`conditional-properties/v2/unified-rules`, {
    query: Object.assign({
      objectTypeId,
      pageSize: 100
    }, query)
  }).then(response => {
    const {
      results,
      offset: newOffset,
      hasMore
    } = response;

    if (hasMore) {
      return fetchConditionalPropertyRules(objectTypeId, http, Object.assign({}, query, {
        offset: newOffset
      })).then(rules => results.concat(rules));
    }

    return results;
  });
};